"use client";

import Header from "@/components/layout/Header";
import Hero from "@/components/landing/Hero";
import KeyBenefits from "@/components/landing/KeyBenefits";
import AppFeatures from "@/components/landing/AppFeatures";
import FeaturedFeature from "@/components/landing/FeaturedFeature";
import IntermediateCTA from "@/components/landing/IntermediateCTA";
import ViewDemo from "@/components/landing/ViewDemo";
import FAQ from "@/components/landing/FAQ";
import Pricing from "@/components/landing/Pricing";
import ContactForm from "@/components/landing/ContactForm";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";

export default function Home() {
  return (
    <>
      <Header />
      <main>
        {/* Hero Section */}
        <Hero />

        {/* Key Benefits Section */}
        <KeyBenefits />

        {/* App Features Section (includes La nueva era + Beneficios + Todo tu campo + Muestreo) */}
        <AppFeatures />

        {/* Featured Feature Section (2x2 Grid: Reportes + Transformación) */}
        <FeaturedFeature />

        {/* Intermediate CTA Section (Experimente el futuro) */}
        <IntermediateCTA />

        {/* View Demo Section */}
        <ViewDemo />

        {/* FAQ Section */}
        <FAQ />

        {/* Pricing Section */}
        <Pricing />

        {/* Contact Form */}
        <ContactForm />

        {/* Final CTA Section */}
        <FinalCTA />
      </main>
      <Footer />
    </>
  );
}
